<template>
  <div class="form-group">
    <slot name="label">
      <label v-if="label" class="control-label">{{label}}</label>
    </slot>
    <slot>
      <label class="form-control">{{value}}</label>
    </slot>
  </div>
</template>
<script>
export default {
  inheritAttrs: false,
  name: "ttw-label",
  props: {
    label: {
      type: String,
      description: "label"
    },
    value: {
      type: [String, Number],
      description: "value"
    }
  },
  model: {
    prop: "value",
    event: "input"
  },
  data() {
    return {
      focused: false
    };
  }
};
</script>
